'use client';

import { useAuth } from '@/platform/auth/useAuth';
import { needsTermsAcceptance } from '@/platform/users/api';
import { TERMS_REQUIRED_MESSAGE } from '@/platform/youtube/validate';

export function useComposePolicy() {
  const { profile } = useAuth();

  function validateTexts(_texts: string[]): string | null {
    if (needsTermsAcceptance(profile)) {
      return TERMS_REQUIRED_MESSAGE;
    }
    return null;
  }

  return { validateTexts };
}
